export default "__VITE_ASSET__BY6bIZH5__"